module.exports = __webpack_public_path__ + "img/new-zealend-logo-icon.291ae997.png";